const ROUTES_AUTH = Object.freeze({
    signIn: () => '/sign-in',
    signUp: () => '/sign-up',
    forgotPassword: () => '/forgot-password',
    paymentSetup: () => '/payment-setup',
    blockedPage: () => '/blocked',
    blacklistedPage: () => '/blacklisted',
    purchaseSuccess: () => '/purchase-success',
});
const ROUTES_ACCOUNT = Object.freeze({
    home: () => '/',
    account: () => '/account',
    accountDashboard: () => '/account/dashboard',
});
const ROUTES_MARKETPLACE = Object.freeze({
    extensionList: () => '/account/extensions',
    extensionDetails: (id = ':id') => `/account/extension/${id}`,
});
const ROUTES_ADMIN_MARKETPLACE = Object.freeze({
    adminExtensionList: () => '/account/admin/extensions/list',
    adminExtensionEdit: (id = ':id') => `/account/admin/extensions/edit/${id}`,
    adminExtensionCreate: () => '/account/admin/extensions/create',
    adminExtensionStatistics: (id = ':id') => `/account/admin/extensions/statistics/${id}`,
});
const ROUTES_ANALYTICS = Object.freeze({
    analytics: () => '/account/analytics',
    meetingHistory: () => '/account/meeting-history',
});
const SSO_ROUTES = Object.freeze({
    adminSsoServices: () => '/account/admin/sso-services/list',
    adminSsoServiceEdit: () => `/account/admin/sso-services/edit/:id`,
    adminSsoServiceCreate: () => '/account/admin/sso-services/create',
});
export const ROUTES = Object.freeze({
    ...ROUTES_AUTH,
    ...ROUTES_ACCOUNT,
    ...ROUTES_MARKETPLACE,
    ...ROUTES_ADMIN_MARKETPLACE,
    ...ROUTES_ANALYTICS,
    ...SSO_ROUTES,
});
export default ROUTES;
